
import './App.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Register from './Components/Register';
import Sidebar from './Components/Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import Detector from './Components/Detector';
import React from 'react';
import Login from './Login';
import Alerts from './Components/Alerts';
import Config from './Components/Config';
import Updates from './Components/Updates';
import GeneralInfo from './Components/GeneralInfo';
import useToken from './useToken';
import UsersManagement from './Components/UsersManagement';

function App() {
  document.body.style.zoom = "100%";
  //const [login, setLogin] = React.useState(false);
  const { token, setToken } = useToken();
  const email = localStorage.getItem("Login");

  localStorage.setItem("timeScale", "2 Hours")

  if (!token) {
    return <Login setToken={setToken} />
  }

  return (
    <Router>
      <div className="flex">
        <Sidebar setToken={setToken} />
        <div className="content">
          <Switch>
            <Route path='/' exact render={(props) => (
              <GeneralInfo {...props} setToken={setToken} />
            )} />
            <Route path="/register" exact={true} component={Register} />
            <Route path="/alerts" exact={true} component={Alerts} />
            <Route path="/detector" exact={true} component={Detector} />
            <Route path="/config" exact={true} component={Config} />
            {email === "ldi@asdt.eu" ? <Route path="/users" exact={true} component={UsersManagement} /> : null}
            {email === "admin@asdt.eu" ? <Route path="/users" exact={true} component={UsersManagement} /> : null}
          </Switch>
        </div>
      </div>
    </Router>
  );


}

export default App;
